import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { getHomePage } from '../helpers/utils';
import { useSelector } from 'react-redux';
import { userRole } from '../store/selectors/auth.selector';
import getItemFromLocalStorage from '../utils/getItemFromLocalStorage';

const PublicRoute = ({ component, path }) => {
  const token = getItemFromLocalStorage('accessToken');
  const role = useSelector(userRole);
  return token ? <Redirect to={{ pathname: getHomePage(role)}} /> : <Route path={path} exact component={component} />;
};

export default PublicRoute;